import { render, staticRenderFns } from "./OpenAIChannels.vue?vue&type=template&id=248acb8c&scoped=true"
import script from "./OpenAIChannels.vue?vue&type=script&lang=js"
export * from "./OpenAIChannels.vue?vue&type=script&lang=js"
import style0 from "./OpenAIChannels.vue?vue&type=style&index=0&id=248acb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248acb8c",
  null
  
)

export default component.exports